module.exports = __webpack_public_path__ + "img/siren.81f97000.gif";